import { WidthVariants } from '../types';
export const getWidth = (width) => {
    switch (true) {
        case ['number', 'object'].includes(typeof width):
        case /(?:%|px|vw)$/u.test(`${width}`):
            return width;
        case width === WidthVariants.large:
            return '808px';
        case width === WidthVariants.medium:
            return '676px';
        case width === WidthVariants.small:
        default:
            return '442px';
    }
};
//# sourceMappingURL=getWidth.js.map